import { NavLink, useLocation } from 'react-router-dom';
import cn from 'classnames';

function NavItem({ menuItem, children }: { menuItem: string; children: React.ReactNode }) {
  const location = useLocation();

  return (
    <div className="group inline-flex flex-col px-2">
      <NavLink
        to={`/super-admin/${menuItem}`}
        className="inline-flex items-center py-2"
        role="menuitem"
      >
        {children}
      </NavLink>
      <div
        className={cn('w-full h-0.5 group-hover:bg-white rounded-full', {
          'bg-white': location.pathname.endsWith(menuItem),
        })}
      />
    </div>
  );
}

export function SuperAdminHeader() {
  return (
    <>
      <h2 className="text-2xl font-bold sm:text-3xl leading-7 text-white">Super Admin</h2>
      <div className="mb-10 text-white">
        <div className="inline-flex items-center mb-5 text-white">
          <NavItem menuItem="dashboard">Dashboard</NavItem>
          <NavItem menuItem="applications">Applications</NavItem>
          <NavItem menuItem="plan-settings">Plan Settings</NavItem>
        </div>
      </div>
    </>
  );
}
